"use client";

import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface NameFieldsProps {
  firstName: string;
  lastName: string;
  errors: { firstName: string; lastName: string };
  disabled?: boolean;
  onFirstNameChange: (v: string) => void;
  onLastNameChange: (v: string) => void;
  firstNameRef: React.RefObject<HTMLInputElement>;
  lastNameRef: React.RefObject<HTMLInputElement>;
}

const NameFields: React.FC<NameFieldsProps> = ({
  firstName,
  lastName,
  errors,
  disabled = false,
  onFirstNameChange,
  onLastNameChange,
  firstNameRef,
  lastNameRef,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2 col-span-2">
        <Label htmlFor="firstName">{t("contactDetails.firstName")}</Label>
        <Input
          id="firstName"
          type="text"
          value={firstName}
          onChange={(e) => onFirstNameChange(e.target.value)}
          maxLength={70}
          className={cn(errors.firstName && "border-destructive focus-visible:ring-destructive")}
          disabled={disabled}
          ref={firstNameRef}
        />
        {errors.firstName && <p className="text-sm text-destructive">{errors.firstName}</p>}
      </div>
      <div className="space-y-2 col-span-2">
        <Label htmlFor="lastName">{t("contactDetails.lastName")}</Label>
        <Input
          id="lastName"
          type="text"
          value={lastName}
          maxLength={70}
          onChange={(e) => onLastNameChange(e.target.value)}
          className={cn(errors.lastName && "border-destructive focus-visible:ring-destructive")}
          disabled={disabled}
          ref={lastNameRef}
        />
        {errors.lastName && <p className="text-sm text-destructive">{errors.lastName}</p>}
      </div>
    </div>
  );
};

export default NameFields;
